import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import MarketingAutomacoesEditPage from '@/pages/dashboard/marketing-automacoes-edit-page'
import { RequireModule } from '@/components/auth'
import { MODULES } from '@/constants/modules'

const automacaoNovaEditarSearchSchema = z.object({
  template: z.string().optional(),
})

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/automacoes/nova/editar',
)({
  validateSearch: automacaoNovaEditarSearchSchema,
  component: function MarketingAutomacoesNovaEditarRoute() {
    const { dashboardId } = Route.useParams()
    const { template } = Route.useSearch()

    return (
      <RequireModule module={MODULES.AUTOMACOES} dashboardId={dashboardId}>
        <MarketingAutomacoesEditPage
          mode="create"
          templateId={template}
          dashboardId={dashboardId}
        />
      </RequireModule>
    )
  },
})
